import styled from 'styled-components';

export var StyledForm = styled.form.withConfig({
  displayName: 'StyledForm',
  componentId: 'rr1xyd-0'
})(['width:100%;']);


//////////////////
// WEBPACK FOOTER
// ./node_modules/grommet-controls/es6/components/Form/StyledForm.js
// module id = 1155
// module chunks = 0